import type { DocumentDrawerOptions } from '../../../../views/DocumentDrawer';
import type { Money } from '../../../../lib/Money.ts';
import type { Subledger } from '../../SubledgerSelector';
import type {PresentationSourceType, VatCode} from '../../../../generated/enums.ts';

// --- Legacy DrillDown types (used by DrillDownModal / VatDeclaration) ---

export enum DrillDownType {
    BILL = 'bill',
    TRANSACTION = 'transaction',
}

interface DrillDownRowBase {
    id: string;
    relation_name: string | null;
    date: string | null;
    totalAmount: number | null;
    currency: string | null;
    netAmount?: number | null;
    vatAmount?: number | null;
}

export interface BillDrillDownRow extends DrillDownRowBase {
    type: DrillDownType.BILL;
    documentId: string;
    file_name: string | null;
    documentDrawerOptions?: DocumentDrawerOptions;
}

export interface TransactionDrillDownRow extends DrillDownRowBase {
    type: DrillDownType.TRANSACTION;
    transactionId: string;
    description: string | null;
}

export type DrillDownRow = BillDrillDownRow | TransactionDrillDownRow;

// --- BookingSource types (used by DrillDownDrawer / Trial Balance) ---

export interface BookingSourceBase {
    source_type_for_presentation: PresentationSourceType;
    resource_id: string;
    source_date: string;
    description: string;
}

export interface BillSource extends BookingSourceBase {
    source_type_for_presentation: 'BILL';
    bill_id: string;
    document_id?: string | null;
    file_name?: string | null;
    relation_name?: string | null;
    invoice_number?: string | null;
    line_item_id?: string | null;
    vat_rate_percentage: number | null;
}
export interface TransactionSource extends BookingSourceBase {
    source_type_for_presentation: 'TRANSACTION';
    transaction_id: string;
    relation_name?: string | null;
    vat_code: VatCode | null;
}
export interface ManualBookingSource extends BookingSourceBase {
    source_type_for_presentation: 'MANUAL_BOOKING';
    booking_id: string;
    line_id: string;
}
export interface FixedAssetSource extends BookingSourceBase {
    source_type_for_presentation: 'FIXED_ASSET';
    fixed_asset_id: string;
}
export interface MatchSource extends BookingSourceBase {
    source_type_for_presentation: 'MATCH';
    match_id: string;
    bill_ids?: string[];
    transaction_ids?: string[];
}

export type BookingSource = BillSource | TransactionSource | ManualBookingSource | FixedAssetSource | MatchSource;

export interface DrillDownLine {
    debit_amount: Money;
    credit_amount: Money;
    sources: BookingSource[];
    description: string | null;
    booking_id: string | null;
    booking_date: string | null;
    subledger?: Subledger | null;
}

export interface DocumentSettlement {
    bill_ids: string[];
    invoice_number: string | null;
    relation_name: string | null;
    total_amount: Money;
    open_amount: Money;
    is_settled: boolean;
}
